var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.$options.breadcrumb}}),_c('b-card-group',{attrs:{"deck":""}},_vm._l((_vm.list),function(entry){return _c('printer-card',{key:entry.id,attrs:{"id":entry.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }